module Meevo.Plugins.AlertsManager {

    import IAlertJSON = Meevo.Model.IAlertJSON;

    interface IClosingCashAlertJson extends IAlertJSON {
        maximumAllowedAmount: number;
    }

    class MeevoClosingCashComponent extends BaseConfigComponent implements ng.IComponentController {

        static $inject = [
            'meevo.plugins.alertsManager.AlertsManagerService',
            '$translate'
        ];

        public params: IParams;
        public data: ISingleMoverData;

        public currencyModel: number = 1;

        get dataForReview() {
            return [
                `${this.$translate.instant('LABEL_MAXIMUM_ALLOWED_OS_AMOUNT')} ${this.currencyModel}`
            ];
        }

        get alertConfiguration() {
            return {
                maximumAllowedAmount: this.currencyModel
            }
        }

        constructor(protected alertsManagerService: IAlertsManagerService,
                    protected $translate: angular.translate.ITranslateService) {
            super(alertsManagerService);
        }

        onEdit(alertJSON: IClosingCashAlertJson): void {
            this.currencyModel = alertJSON.maximumAllowedAmount;
        }
    }

    angular.module('meevo.plugins.alertsManager')
        .component('meevoClosingCashComponent', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/alertsManager/addNewAlert/config-components/closing-cash-config/closing-cash-config.component.html',
            controller: MeevoClosingCashComponent,
            controllerAs: '$ctrl',
            bindings: {
                params: '<',
                data: '<'
            }
        });
}
